import React from 'react';
import PropTypes from 'prop-types';

import './graph.scss';
import Strings from '../../Strings';
import GenericCategoryGraph from './GenericCategoryGraph';

export default function AdherenceDistributionGraph(props) {
  const { graphData, colorPalette } = props;
  const dataSeries = [
    {
      name: 'Adherence',
      color: colorPalette?.interpolate(0.73),
      selector: item => item.adherence,
    },
  ];

  return (
    <GenericCategoryGraph
      graphData={graphData}
      hasBorder={true}
      forceCondensed
      xAxisTopPosition={false}
      yAxisWidth={40}
      yAxisUnit=""
      tooltipTitle={Strings.adherence}
      dataSeries={dataSeries}
      categorySelector={item => item.range}
      hasReferenceAreas={true}
      graphType={props.graphType}
      colorPalette={colorPalette}
    />
  );
}

AdherenceDistributionGraph.propTypes = { graphData: PropTypes.array };
